<form
  [formGroup]="formGroup"
  (ngSubmit)="selectUser()">
  <div class="swd-control-bar">
    <div class="swd-form-group">
      <div class="swd-form-control">
        <label
          [class.ng-invalid]="userEmail!.invalid"
          class="swd-form-label">
          {{ 'app.forms.labels.user' | translate }}
        </label>
        <p-autocomplete
          [suggestions]="suggestions()"
          (completeMethod)="searchUserByEmail($event)"
          formControlName="userEmail"
          styleClass="swd-autocomplete ng-invalid"
          panelStyleClass="swd-autocomplete-overlay"
          appendTo="body" />
      </div>
    </div>
  </div>
  <footer class="swd-form-actions--right">
    <button
      (click)="cancel()"
      type="button"
      class="swd-button small secondary">
      {{ 'app.forms.cancel' | translate }}
    </button>
    <button
      [disabled]="formGroup.invalid"
      type="submit"
      class="swd-button small primary">
      {{ 'app.forms.create' | translate }}
    </button>
  </footer>
</form>
